// extracted by mini-css-extract-plugin
export var modal = "_ti-0";
export var table = "_ti-1";